import moment from "moment";
import { CommonEntity } from "../interfaces";
import { capitalizeString, getCityNameByCode } from "../shared/util";

export class CommonsEntityAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get name() {
        return capitalizeString(this.value.name || '');
    }

    get contact_name() {
        return capitalizeString(this.value.contact_name || '');
    }

    get contact_email() {
        return this.value.contact_email || '';
    }

    get update_date() {
        return moment(this.value.update_date).format("YYYY-MM-DD");
    }
    get created_at() {
        return moment(this.value.created_at).format("YYYY-MM-DD");
    }

    get issue_date() {
        return moment(this.value.issue_date).format("YYYY-MM-DD");
    }

    get updated_at() {
        return moment(this.value.updated_at).format("YYYY-MM-DD");
    }

    get city() {
        if (!this.value.city) {
            return this.value.cityRaw || 'No Informa'
        }

        return getCityNameByCode(this.value.city)?.municipio || 'No definido';
    }

    get state() {
        if (!this.value.state) {
            return this.value.stateRaw || 'No Informa'
        }
        return getCityNameByCode(this.value.city)?.departamento || 'No definido';
    }

    get ciudad() {
        return getCityNameByCode(this.value.city)?.municipio || 'No definido';
    }

    get recognized_min() {
        return this.value.recognized_min === 1 ? "Si" : "No";
    }

    get type() {
        return this.value.type;
    }

    adapt(): CommonEntity {
        return {
            id: this.value.id,
            city: this.city,
            cityRaw: this.value.cityRaw,
            state: this.state,
            name: this.name,
            recognized_min: this.recognized_min,
            type: this.type,
            recommended: this.value.recommended,
            collection_name: this.value.type.collection_name,
            contact_email: this.value.contact_email,
            contact_name: this.value.contact_name
        };
    }
}
